import React, { useEffect, useState } from 'react';
import {
    Box,
    Modal,
    Typography,
    Select,
    IconButton,
    Divider,
    Menu,
    MenuItem,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { productDetails } from '../Redux/Products/action';
import { toast } from 'react-toastify';
import SelectBox from './SelectBox';
import Input from './Input';
import ButtonBox from './Button';
import { storage } from '../Config/Storage';
import { addproduct } from '../Redux/Mycart/action';
import Loader from './Loader';
import Styles from '../Config/Styles';

const ProductDetails = ({ open, handleClose, id, setLoading, loading }) => {
    const dispatch = useDispatch();
    const { productDetail } = useSelector((state) => state?.ProductsData) || [];
    const [value, setValue] = useState('');
    const [cart, setCart] = useState(storage.fetch.cart() || []);
    const [selectedValues1, setSelectedValues1] = useState([]);
    const [unit, setUnit] = useState();

    // Fetch product details when `id` changes
    useEffect(() => {
        if (id !== null)
            setLoading(true);
        setValue('');
        dispatch(productDetails({ id }, setLoading));
    }, [id, dispatch]);

    // Log product details when they change
    useEffect(() => {
        setUnit(productDetail?.units[0]?.units_id?.name)
    }, [productDetail]);

    // Handle adding a product to the cart
    const handleAddProduct = (data) => {
        setLoading(true)
        const newCartItem = { ...data, quantity: value };
        const payload = {
            product: data?.id,
            product_name: data?.name,
            status: "1",
            quantity: value,
            Status: "draft",
            session: sessionStorage.getItem("session"),
            unit: unit,
            order_image: data?.product_image,
        };


        if (storage.fetch.rfq()) {
            setTimeout(() => toast.error("Please clear the cart to add products."), 1000);
        } else {
            setCart([...cart, newCartItem]);
            storage.set.cart([...cart, newCartItem]);
            dispatch(addproduct(payload, selectedValues1, setLoading));
            handleClose();
        }
    };

    return (
        <Modal className="box" open={open} onClose={handleClose} sx={Styles.productsdetails.modal}>
            <Box sx={Styles.productsdetails.box}>
                <Loader open={loading} />

                {/* Close Button */}
                <Box sx={Styles.productsdetails.iconbox}>
                    <IconButton sx={Styles.productsdetails.icon} onClick={handleClose}>
                        <CloseIcon sx={Styles.productsdetails.closebtn} />
                    </IconButton>
                </Box>

                {/* Product Image */}
                <Box sx={Styles.productsdetails.imgbox}>
                    <img
                        src={
                            productDetail?.product_image
                                ? `https://api-dev.tabta.net/assets/${productDetail?.product_image}?key=system-large-contain`
                                : require('../assets/dummy.jpg')
                        }
                        alt="Product"
                        style={Styles.productsdetails.img}
                    />
                </Box>

                {/* Product Details */}
                <Box sx={Styles.productsdetails.innerbox}>
                    <Typography variant="h6" sx={Styles.productsdetails.typo}>
                        {productDetail?.name}
                    </Typography>
                    <Divider sx={Styles.productsdetails.divider} />

                    {/* Attribute Selection */}
                    {productDetail?.fields && (
                        <SelectBox
                            data={productDetail?.fields}
                            selectedValues1={selectedValues1}
                            setSelectedValues1={setSelectedValues1}
                        />
                    )}

                    {/* Quantity Input */}
                    <Box sx={Styles.productsdetails.qtybox}>
                        <Typography sx={Styles.productsdetails.label}>
                            Quantity<span style={Styles.productsdetails.valid}>*</span>
                        </Typography>
                        <Box sx={Styles.productsdetails.inputbox}>
                            <Input
                                quantity
                                type="text"
                                value={value}
                                setValue={setValue}
                                placeholder="Enter Quantity"
                            />
                            <Box sx={Styles.productsdetails.unitbox}>
                                {productDetail?.units?.length === 1 ? (
                                    <Typography>{unit}</Typography>
                                ) : (
                                    <Select
                                        sx={Styles.select.input}
                                        value={unit}
                                        onChange={(e) => setUnit(e.target.value)}
                                    >
                                        {productDetail?.units?.map((item) =>
                                            <MenuItem value={item.units_id.name}>
                                                {item.units_id.name}
                                            </MenuItem>
                                        )}
                                    </Select>
                                )}
                            </Box>
                        </Box>
                    </Box>

                    {/* Add Product Button */}
                    <ButtonBox
                        color="black"
                        text="Add Product"
                        disabled={value === ''}
                        onClick={() => handleAddProduct(productDetail)}
                    />
                </Box>
            </Box>
        </Modal>
    );
};

export default ProductDetails;
